import gql from "graphql-tag";
import AnswerablePostFields from "lib/graphql/fragments/engagement/AnswerablePostFields";

export default gql`
  mutation SetPostReplyAnswer($replyId: ObjectID!) {
    setPostReplyAnswer(replyId: $replyId) {
      ...AnswerablePostFields
    }
  }

  ${AnswerablePostFields}
`;
